import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const ArrowsUpDownIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 15C11.7761 15 12 14.7761 12 14.5V2.70711L15.1464 5.85355C15.3417 6.04882 15.6583 6.04882 15.8536 5.85355C16.0488 5.65829 16.0488 5.34171 15.8536 5.14645L11.8536 1.14645C11.6583 0.951184 11.3417 0.951184 11.1464 1.14645L7.14645 5.14645C6.95118 5.34171 6.95118 5.65829 7.14645 5.85355C7.34171 6.04882 7.65829 6.04882 7.85355 5.85355L11 2.70711V14.5C11 14.7761 11.2239 15 11.5 15Z",
    fill: color
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 1C4.77614 1 5 1.22386 5 1.5V13.2929L8.14645 10.1464C8.34171 9.95118 8.65829 9.95118 8.85355 10.1464C9.04882 10.3417 9.04882 10.6583 8.85355 10.8536L4.85355 14.8536C4.65829 15.0488 4.34171 15.0488 4.14645 14.8536L0.146447 10.8536C-0.0488155 10.6583 -0.0488155 10.3417 0.146447 10.1464C0.341709 9.95118 0.658292 9.95118 0.853554 10.1464L4 13.2929V1.5C4 1.22386 4.22386 1 4.5 1Z",
    fill: color
  }));
};
export default ArrowsUpDownIcon;